module.exports = "/assets/data/cb58044810f8fb1b52b962bdc190f254-CF31.data.json";